import {
  exportExcel,
  getYeHuList,
  makePackage,
  downloadPackage,
  getClientYeHuList,
  makeDangerousFile,
  downloadDangerousFile,
  clientExportExcel,
} from '@/api/gpsstandingbookserv'

export default {
  state: {
    state_GpsStandingBook_ExportExcelResult: null,
    state_GpsStandingBook_GetYeHuListResult: null,
    state_GpsStandingBook_MakePackageResult: null,
    state_GpsStandingBook_DownloadPackageResult: null,
    state_GpsStandingBook_GetClientYeHuListResult: null,
    state_GpsStandingBook_MakeDangerousFileResult: null,
    state_GpsStandingBook_DownloadDangerousFileResult: null,
    state_GpsStandingBook_ClientExportExcelResult: null,
  },
  mutations: {
    SET_GPSSTANDINGBOOK_EXPORTEXCEL_RESULT: (state, rst) => {
      state.state_GpsStandingBook_ExportExcelResult = rst;
    },
    SET_GPSSTANDINGBOOK_GETYEHULIST_RESULT: (state, rst) => {
      state.state_GpsStandingBook_GetYeHuListResult = rst;
    },
    SET_GPSSTANDINGBOOK_MAKEPACKAGE_RESULT: (state, rst) => {
      state.state_GpsStandingBook_MakePackageResult = rst;
    },
    SET_GPSSTANDINGBOOK_DOWNLOADPACKAGE_RESULT: (state, rst) => {
      state.state_GpsStandingBook_DownloadPackageResult = rst;
    },
    SET_GPSSTANDINGBOOK_GETCLIENTYEHULIST_RESULT: (state, rst) => {
      state.state_GpsStandingBook_GetClientYeHuListResult = rst;
    },
    SET_GPSSTANDINGBOOK_MAKEDANGEROUSFILE_RESULT: (state, rst) => {
      state.state_GpsStandingBook_MakeDangerousFileResult = rst;
    },
    SET_GPSSTANDINGBOOK_DOWNLOADDANGEROUSFILE_RESULT: (state, rst) => {
      state.state_GpsStandingBook_DownloadDangerousFileResult = rst;
    },
    SET_GPSSTANDINGBOOK_CLIENTEXPORTEXCEL_RESULT: (state, rst) => {
      state.state_GpsStandingBook_ClientExportExcelResult = rst;
    },
  },
  actions: {
    GpsStandingBookServ_ExportExcel({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        exportExcel(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_GPSSTANDINGBOOK_EXPORTEXCEL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_GPSSTANDINGBOOK_EXPORTEXCEL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    GpsStandingBookServ_GetYeHuList({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getYeHuList(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_GPSSTANDINGBOOK_GETYEHULIST_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_GPSSTANDINGBOOK_GETYEHULIST_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    GpsStandingBookServ_MakePackage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        makePackage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_GPSSTANDINGBOOK_MAKEPACKAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_GPSSTANDINGBOOK_MAKEPACKAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    GpsStandingBookServ_DownloadPackage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        downloadPackage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_GPSSTANDINGBOOK_DOWNLOADPACKAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_GPSSTANDINGBOOK_DOWNLOADPACKAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    GpsStandingBookServ_GetClientYeHuList({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getClientYeHuList(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_GPSSTANDINGBOOK_GETCLIENTYEHULIST_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_GPSSTANDINGBOOK_GETCLIENTYEHULIST_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    GpsStandingBookServ_MakeDangerousFile({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        makeDangerousFile(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_GPSSTANDINGBOOK_MAKEDANGEROUSFILE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_GPSSTANDINGBOOK_MAKEDANGEROUSFILE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    GpsStandingBookServ_DownloadDangerousFile({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        downloadDangerousFile(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_GPSSTANDINGBOOK_DOWNLOADDANGEROUSFILE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_GPSSTANDINGBOOK_DOWNLOADDANGEROUSFILE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    GpsStandingBookServ_ClientExportExcel({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        clientExportExcel(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_GPSSTANDINGBOOK_CLIENTEXPORTEXCEL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_GPSSTANDINGBOOK_CLIENTEXPORTEXCEL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_GpsStandingBook_ExportExcelResult: state => {
      return state.state_GpsStandingBook_ExportExcelResult;
    },
    get_GpsStandingBook_GetYeHuListResult: state => {
      return state.state_GpsStandingBook_GetYeHuListResult;
    },
    get_GpsStandingBook_MakePackageResult: state => {
      return state.state_GpsStandingBook_MakePackageResult;
    },
    get_GpsStandingBook_DownloadPackageResult: state => {
      return state.state_GpsStandingBook_DownloadPackageResult;
    },
    get_GpsStandingBook_GetClientYeHuListResult: state => {
      return state.state_GpsStandingBook_GetClientYeHuListResult;
    },
    get_GpsStandingBook_MakeDangerousFileResult: state => {
      return state.state_GpsStandingBook_MakeDangerousFileResult;
    },
    get_GpsStandingBook_DownloadDangerousFileResult: state => {
      return state.state_GpsStandingBook_DownloadDangerousFileResult;
    },
    get_GpsStandingBook_ClientExportExcelResult: state => {
      return state.state_GpsStandingBook_ClientExportExcelResult;
    },
  }
}